import type { BrandPaymentConfig } from '../types'
import { storlynPaymentConfig } from './storlyn'

const roseGradient = 'linear-gradient(135deg, #F492AC 0%, #E05A7E 100%)'
const goldGradient = 'linear-gradient(135deg, #EFCE7A 0%, #C9A227 100%)'

export const novelynPaymentConfig: BrandPaymentConfig = {
  ...storlynPaymentConfig,
  brand: 'novelyn',
  pay: {
    ...storlynPaymentConfig.pay,
    theme: {
      ...storlynPaymentConfig.pay.theme,
      paymentStickyGradient: 'linear-gradient(to top, #FDF6F7 0%, #FDF6F7 55%, rgba(253,246,247,0) 100%)',
      colors: {
        ...storlynPaymentConfig.pay.theme?.colors,
        pageBg: '#FDF6F7',
        cardBg: '#FFFFFF',
        cardBorder: '#F5E4EA',
        cardActiveBorder: '#E4587F',
        cardActiveShadow: 'rgba(201, 63, 104, 0.16)',
        cardRightBg: '#FDF0F4',
        bonusPillBg: '#FBE3EA',
        bonusPillText: '#C93F68',
        bonusRateText: '#C93F68',
        bottomBarBg: 'rgba(255,255,255,.94)',
        bottomBarBorder: '#F5E4EA',
        totalHighlight: '#E4587F',
        payBtnGradient: roseGradient,
        payBtnShadow: 'rgba(224, 90, 126, .3)',
        tagGradient: roseGradient,
      },
    },
    resources: {
      goldCoinIcon: '/images/novelyn/coin.svg',
    },
  },
  subscribe: {
    ...storlynPaymentConfig.subscribe,
    resources: {
      vipBg: '/images/novelyn/vip-card.svg',
      memberSubscribeBg: '/images/novelyn/vip-card.svg',
      vipIcon: '/images/novelyn/vip.svg',
      vipDiscountIcon: '/images/novelyn/vip.svg',
      discountBg: '/images/novelyn/discount.svg',
      showVipIcon: true,
    },
    colors: {
      ...storlynPaymentConfig.subscribe.colors,
      redGradient: roseGradient,
      purpleTextGradient: 'linear-gradient(180deg, #A97FD8 0%, #8E5FC4 100%)',
      subscribeText1: '#E4587F',
      subscribeText2: '#402A33',
      subscribeText3: '#9C8590',
      subscribeText4: '#9C8590',
      subscribeImagePrice: '#5C430A',
      subscribeCardBg: 'linear-gradient(120deg, #FFFFFF 0%, #FDF0F4 100%)',
      cycleTextGradient: roseGradient,
      badgeGradient: roseGradient,
      pageBg: '#FDF6F7',
      paymentCardBg: '#FFFFFF',
      paymentCardBorder: '#F5E4EA',
      paymentCardActiveBorder: '#E4587F',
      tagGradient: goldGradient,
      titleColor: '#402A33',
      schemes: {
        discounted: {
          bg: 'linear-gradient(120deg, #FBE3EA 0%, #FDF0F4 100%)',
          priceBg: roseGradient,
          titleColor: '#402A33',
          descColor: '#9C8590',
          borderColor: '#F5E4EA',
          unitPriceColor: '#9C8590',
          originalPriceColor: '#9C8590',
          cycleLabelBg: '#FBE3EA',
          cycleLabelColor: '#C93F68',
        },
        normal: {
          bg: 'linear-gradient(120deg, #F1E9FB 0%, #FFFFFF 100%)',
          priceBg: 'linear-gradient(135deg, #C4A1E8 0%, #9C6FD0 100%)',
          titleColor: '#402A33',
          descColor: '#9C8590',
          borderColor: '#EEE2F7',
          unitPriceColor: '#9C8590',
          originalPriceColor: '#9C8590',
          cycleLabelBg: '#F1E9FB',
          cycleLabelColor: '#8E5FC4',
        },
        fakeDiscount: {
          bg: 'linear-gradient(120deg, #FBF3DC 0%, #FFF9EA 100%)',
          priceBg: goldGradient,
          titleColor: '#5C430A',
          descColor: '#9A7A1B',
          borderColor: '#F5E8BD',
          unitPriceColor: '#9A7A1B',
          originalPriceColor: '#9A7A1B',
          cycleLabelBg: '#FBF3DC',
          cycleLabelColor: '#9A7A1B',
        },
      },
    },
  },
  chapter: {
    ...storlynPaymentConfig.chapter,
    colors: {
      ...storlynPaymentConfig.chapter.colors,
      coinsGradient: goldGradient,
      coinsPopupText1: '#402A33',
      coinsPopupText2: '#C9A227',
      coinsPopupText3: '#9C8590',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFFFFF',
      subscribeActiveBg: '#FDF0F4',
      purpleTextGradient: 'linear-gradient(180deg, #A97FD8 0%, #8E5FC4 100%)',
      pinkGradient: roseGradient,
      subscribeCardBg: 'linear-gradient(120deg, #FFFFFF 0%, #FDF0F4 100%)',
      purchaseActiveBg: '#FDF0F4',
      memberSubscribeBg: '/images/novelyn/vip-card.svg',
    },
  },
}
